import { render } from "./index.vue?vue&type=template&id=f2d329c8&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=f2d329c8&lang=scss&scoped=true"

import exportComponent from "D:\\phpstudy_pro\\WWW\\tengxunshipin\\chat-example\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2d329c8"]])

export default __exports__